<template>
  <div>
    <ConfirmIFrame />
  </div>
</template>

<script lang="ts">
import LoadingSpinner from '~/core/components/shared/LoadingSpinner.vue'
import ConfirmIFrame from '~/core/components/legacy/ConfirmIFrame.vue'

import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'

import { translateByKey } from '~/core/ts/util/translate'
import { capitalizeAllWords } from '~/core/ts/util/string'

definePageMeta({
  layout: 'checkout',
})

export default defineNuxtComponent({
  components: {
    LoadingSpinner,
    ConfirmIFrame,
  },
  setup() {
    const builder = HeadMetaBuilder.create()

    const title = capitalizeAllWords(translateByKey('online-booking'))

    builder.withTitleAndMetaTitle(`${title} | Spalopia.com`)

    useHead(builder.get())

    return {
    }
  }
})
</script>

<style lang="scss" scoped>
.contact-form {
  @apply my-4;
  @apply px-6;

  @apply bg-white;
}

#voucher-hbspt-form-target {
  @apply pt-4;
  @apply pb-4;

  @apply overflow-visible;
}
</style>
